import { Injectable } from '@angular/core';

import { WchService } from '../wch.service';
import { UrlConfig } from './../../../api';
import { createGetter } from './../../../utils';

/* Copyright IBM Corp. 2017 */
@Injectable({ providedIn: 'root' })
export class WchInfoService implements UrlConfig {
  /** some global infos. See definitions in UrlConfig */
  apiUrl: URL;
  deliveryUrl: URL;
  isPreviewMode: boolean;

  baseUrl?: URL;

  constructor(wchService: WchService) {
    // instance
    const that = this;

    // accessors
    const _getApiUrl = () => wchService.getApiUrl();
    const _getDeliveryUrl = () => wchService.getDeliveryUrl();
    const _isPreviewMode = () => wchService.isPreviewMode();
    const _getBaseUrl = () => wchService.getBaseUrl();

    // define
    Object.defineProperties(that, {
      apiUrl: createGetter(_getApiUrl),
      deliveryUrl: createGetter(_getDeliveryUrl),
      baseUrl: createGetter(_getBaseUrl),
      isPreviewMode: createGetter(_isPreviewMode)
    });
  }
}
